import {
  Box,
  FontColorEnum,
  FontSizeEnum,
  FontWeightEnum,
  HTMLElementTypeEnum,
  Tooltip,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { ReactNode } from 'react';

type TTableRowProp = {
  title?: string | number | null;
  content?: string | number | ReactNode | null;
  className?: string;

  /**
   * @default false
   */
  showTooltip?: boolean;
};
export function TableRow({ title, content, className, showTooltip = false }: TTableRowProp) {
  const tooltip = content ?? title;
  const row = (
    <Box className="flex flex-col">
      {title && (
        <Typography
          element={HTMLElementTypeEnum.Heading}
          className={clsx(className, 'capitalize', {
            'cursor-pointer underline-offset-2 hover:underline': showTooltip,
          })}
          fontSize={FontSizeEnum.Sm}
          weight={FontWeightEnum.Semibold}
          color={FontColorEnum.Dark10}
        >
          {title}
        </Typography>
      )}

      {content !== undefined && (
        <Typography
          element={HTMLElementTypeEnum.Paragraph}
          className={clsx('FontColorEnum.Dark10 line-clamp-2 capitalize', className, {
            'cursor-pointer underline-offset-2 hover:underline': showTooltip,
          })}
          fontSize={FontSizeEnum.Sm}
        >
          {content}
        </Typography>
      )}
    </Box>
  );

  return tooltip !== undefined && showTooltip ? (
    <Tooltip help={tooltip} grow>
      {row}
    </Tooltip>
  ) : (
    row
  );
}
